import React from "react";
import { Clock } from "lucide-react";

export const TimelineTab = ({ jobs }) => (
    <div className="p-6">
        <div className="bg-white rounded-lg shadow p-6">
            <h3 className="font-semibold text-gray-900 mb-4">Timeline</h3>
            <div className="flex items-center space-x-4 mb-6">
                <select className="border border-gray-300 rounded-lg px-3 py-2 text-sm">
                    <option>All statuses</option>
                    <option>Succeeded</option>
                    <option>Failed</option>
                    <option>Running</option>
                </select>
                <select className="border border-gray-300 rounded-lg px-3 py-2 text-sm">
                    <option>All event types</option>
                    <option>Sync</option>
                    <option>Reset</option>
                </select>
                <button className="border border-gray-300 rounded-lg px-3 py-2 text-sm hover:bg-gray-50">
                    All events to date
                </button>
            </div>

            {jobs.length === 0 ? (
                <div className="text-center py-12 text-gray-500">
                    <Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                    <p>No events to display</p>
                </div>
            ) : (
                <div className="relative">
                    <div className="absolute top-0 bottom-0 left-6 w-px bg-gray-200" />
                    <div className="space-y-8 relative">
                        {jobs.map((job, index) => (
                            <div key={index} className="relative flex items-start group">
                                <div className="absolute left-6 -ml-1.5 mt-1.5 h-3 w-3 rounded-full border-2 border-white bg-gray-300 ring-4 ring-white" />

                                <div className="ml-12 flex-1">
                                    <div className="flex items-center justify-between">
                                        <div>
                                            <p className="text-sm font-medium text-gray-900">{job.status === 'running' ? 'Sync running' : 'Sync started'}</p>
                                            <p className="text-sm text-gray-500 mt-1">
                                                {job.status === 'running' ? 'Sync is currently in progress' :
                                                    job.status === 'succeeded' ? 'Sync completed successfully' :
                                                        job.status === 'failed' ? 'Sync failed' : 'Sync pending'}
                                            </p>
                                            {job.error && (
                                                <div className="mt-2 text-xs text-red-600 bg-red-50 p-2 rounded">
                                                    {job.error}
                                                </div>
                                            )}
                                        </div>
                                        <div className="text-right">
                                            <div className="text-xs text-gray-500">{new Date(job.startTime).toLocaleString()}</div>
                                            {job.rowsSynced > 0 && (
                                                <div className="mt-1 text-xs font-medium text-gray-900">{job.rowsSynced.toLocaleString()} records</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    </div>
);
